"use client";

import React from "react";

export default function WarpOverlay({
  children,
}: {
  children: React.ReactNode;
  intensity?: number;
}) {
  return (
    <div className="relative flex min-h-screen w-full flex-col">
      {children}
    </div>
  );
}
